/** Default and per-section SEO copy for ရွှေကျားဖြူ (slots, fishing, Shan Koe Mee, Bugyi, live casino, card games). */

/** Protocol + host (no trailing slash). Uses the live URL so one build works on ရွှေကျားဖြူ.biz, .cc, .tel, etc. */
export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Absolute canonical URL for a route pathname (must match router SEO / index.html bootstrap).
 * @param {string} [path] pathname e.g. /home (query/hash ignored)
 */
export function getCanonicalUrlForPath(path) {
  const pathname = ((path || '/').split('?')[0] || '/').replace(/\/+$/, '') || '/';
  const origin = getSiteOrigin();
  if (!origin) return '';
  return pathname === '/' ? origin : `${origin}${pathname}`;
}

const BASE_DESC =
  'ရွှေကျားဖြူ offers online slots, fishing arcade games, Shan Koe Mee (Shan poker), Bugyi and classic card games, plus live casino with real dealers. Play securely, fast deposits and withdrawals, promotions for Myanmar players.';

const BASE_KEYWORDS =
  'ရွှေကျားဖြူ, online slots, slot games, fishing game, fishing arcade, Shan Koe Mee, Shan poker, ဘူဂျီ, Bugyi, Bugyee, online card games, live casino, live dealer, baccarat, roulette, Myanmar online casino, jackpot slots';

export const siteDefaults = {
  title: 'ရွှေကျားဖြူ | Online Slots, Fishing, Shan Koe Mee, Bugyi, Live Casino & Card Games',
  description: BASE_DESC,
  keywords: BASE_KEYWORDS,
};

export const pageMeta = {
  home: siteDefaults,

  slots: {
    title: 'Online Slot Games | ရွှေကျားဖြူ — Jackpots & Popular Slots',
    description:
      'Play hundreds of online slot games at ရွှေကျားဖြူ: classic reels, video slots, jackpots and bonus features. Fast play, fair results, mobile-friendly.',
    keywords: `${BASE_KEYWORDS}, video slots, jackpot slots, slot bonus`,
  },

  fishing: {
    title: 'Fishing Arcade Games Online | ရွှေကျားဖြူ',
    description:
      'Shoot-and-catch fishing arcade games at ရွှေကျားဖြူ. Colorful tables, multipliers and real-time action—popular in Myanmar and Southeast Asia.',
    keywords: `${BASE_KEYWORDS}, fishing shooter game, arcade fishing`,
  },

  liveCasino: {
    title: 'Live Casino & Live Dealer Games | ရွှေကျားဖြူ',
    description:
      'Live casino at ရွှေကျားဖြူ: real dealers, HD streams, baccarat, roulette and more. Feel like a real casino floor from your phone or desktop.',
    keywords: `${BASE_KEYWORDS}, live baccarat, live roulette, HD casino stream`,
  },

  shanKoeMee: {
    title: 'Shan Koe Mee Online Rooms | ရွှေကျားဖြူ',
    description:
      'Join Shan Koe Mee (Shan poker) tables at ရွှေကျားဖြူ. Play with friends or match online—authentic card rules and smooth gameplay.',
    keywords: `${BASE_KEYWORDS}, Shan Koe Mee room, Shan poker online`,
  },

  bugyee: {
    title: 'Bugyi (Bugyee) Card Game Online | ရွှေကျားဖြူ',
    description:
      'Play Bugyi / Bugyee card games online at ရွှေကျားဖြူ. Traditional Myanmar-style card play with reliable tables and quick rounds.',
    keywords: `${BASE_KEYWORDS}, Bugyi online, Bugyee card game`,
  },

  cardGames: {
    title: 'Online Card Games & Tables | ရွှေကျားဖြူ',
    description:
      'Card games and table games at ရွှေကျားဖြူ alongside slots and live casino. One account for multiple game types.',
    keywords: `${BASE_KEYWORDS}, table games, multiplayer cards`,
  },

  arcade: {
    title: 'Arcade & Casual Games | ရွှေကျားဖြူ',
    description: 'Arcade and casual games at ရွှေကျားဖြူ—quick fun between slots, fishing and live casino sessions.',
    keywords: `${BASE_KEYWORDS}, arcade games online`,
  },

  promotion: {
    title: 'Casino Promotions & Bonuses | ရွှေကျားဖြူ',
    description:
      'Latest ရွှေကျားဖြူ promotions: welcome offers, reload bonuses and cashback for slots, live casino and card games. Check terms on each offer.',
    keywords: `${BASE_KEYWORDS}, casino bonus, welcome bonus, cashback`,
  },

  login: {
    title: 'Member Login | ရွှေကျားဖြူ',
    description: 'Log in to your ရွှေကျားဖြူ account to play slots, fishing, Shan Koe Mee, Bugyi, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ login`,
  },

  register: {
    title: 'Register & Join | ရွှေကျားဖြူ',
    description:
      'Create a ရွှေကျားဖြူ account in minutes. Access slots, fishing games, Shan Koe Mee, Bugyi, live casino and secure banking.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ register, sign up`,
  },

  contact: {
    title: 'Contact Us | ရွှေကျားဖြူ',
    description: 'Contact ရွှေကျားဖြူ support for account, deposits, withdrawals and game questions.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ support, customer service`,
  },

  rule: {
    title: 'Rules & Terms | ရွှေကျားဖြူ',
    description: 'Rules, terms and responsible play information for ရွှေကျားဖြူ members.',
    keywords: `${BASE_KEYWORDS}, terms and conditions`,
  },

  deposit: {
    title: 'Deposit | ရွှေကျားဖြူ',
    description: 'Deposit funds securely to play slots, fishing, live casino and card games at ရွှေကျားဖြူ.',
    keywords: `${BASE_KEYWORDS}, deposit`,
    robots: 'noindex, nofollow',
  },

  withdraw: {
    title: 'Withdraw | ရွှေကျားဖြူ',
    description: 'Withdraw your winnings from ရွှေကျားဖြူ with supported payment methods.',
    keywords: `${BASE_KEYWORDS}, withdraw`,
    robots: 'noindex, nofollow',
  },

  banking: {
    title: 'Banking | ရွှေကျားဖြူ',
    description: 'Banking and payment options for ရွှေကျားဖြူ members.',
    keywords: `${BASE_KEYWORDS}, banking`,
    robots: 'noindex, nofollow',
  },

  history: {
    title: 'Transaction History | ရွှေကျားဖြူ',
    description: 'View your ရွှေကျားဖြူ transaction history.',
    robots: 'noindex, nofollow',
  },

  setting: {
    title: 'Account Settings | ရွှေကျားဖြူ',
    description: 'Manage your ရွှေကျားဖြူ account settings.',
    robots: 'noindex, nofollow',
  },

  betslip: {
    title: 'Betslip History | ရွှေကျားဖြူ',
    description: 'Your betslip history at ရွှေကျားဖြူ.',
    robots: 'noindex, nofollow',
  },

  liveScore: {
    title: 'Live Score | ရွှေကျားဖြူ',
    description: 'Live scores and sports updates at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  matchResult: {
    title: 'Football Match Results | ရွှေကျားဖြူ',
    description: 'View today and yesterday football match results at ရွှေကျားဖြူ.',
    keywords: `${BASE_KEYWORDS}, football results, match results`,
  },

  maungFb: {
    title: 'Maung FB | ရွှေကျားဖြူ',
    description: 'Maung FB at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  bodyFb: {
    title: 'Body FB | ရွှေကျားဖြူ',
    description: 'Body FB at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  videoLinks: {
    title: 'Video Links | ရွှေကျားဖြူ',
    description: 'Video links and guides at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  commission: {
    title: 'Commission | ရွှေကျားဖြူ',
    description: 'Commission program at ရွှေကျားဖြူ.',
    robots: 'noindex, nofollow',
  },

  level: {
    title: 'VIP Levels | ရွှေကျားဖြူ',
    description: 'VIP levels and rewards at ရွှေကျားဖြူ.',
    keywords: `${BASE_KEYWORDS}, VIP`,
  },

  guides: {
    title: 'App Install Guide | ရွှေကျားဖြူ',
    description: 'Install the ရွှေကျားဖြူ app on Android or iOS for slots, fishing, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ app, install guide`,
  },

  androidGuide: {
    title: 'Android App Install | ရွှေကျားဖြူ — Slots, Fishing & Live Casino',
    description:
      'Install ရွှေကျားဖြူ on Android: play online slots, fishing games, Shan Koe Mee, Bugyi and live casino on your phone.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ Android APK`,
  },

  iosGuide: {
    title: 'iOS App Install | ရွှေကျားဖြူ — Slots, Fishing & Live Casino',
    description:
      'Install ရွှေကျားဖြူ on iPhone or iPad: slots, fishing arcade, card games and live dealer casino.',
    keywords: `${BASE_KEYWORDS}, ရွှေကျားဖြူ iOS app`,
  },

  dreamBooks: {
    title: 'Dream Books | ရွှေကျားဖြူ',
    description: 'Dream books feature at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  twoD: {
    title: '2D | ရွှေကျားဖြူ',
    description: '2D games at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  threeD: {
    title: '3D | ရွှေကျားဖြူ',
    description: '3D games at ရွှေကျားဖြူ.',
    keywords: BASE_KEYWORDS,
  },

  landing: {
    title: 'ရွှေကျားဖြူ — Slots, Fishing, Live Casino & Card Games',
    description: BASE_DESC,
    keywords: BASE_KEYWORDS,
  },

  iframe: {
    title: 'Game | ရွှေကျားဖြူ',
    robots: 'noindex, nofollow',
  },

  verify: {
    title: 'Verify Account | ရွှေကျားဖြူ',
    robots: 'noindex, nofollow',
  },

  dataTable: {
    title: 'Data | ရွှေကျားဖြူ',
    robots: 'noindex, nofollow',
  },
};
